import { TdsTcsTypes } from "./tdsTcsManagementType";

export const tdsTcsManagementReducer = {
  resetTdsTcsManagementError: (state: TdsTcsTypes) => {
    state.error = null;
  },
  resetTdsTcsManagementSuccess: (state: TdsTcsTypes) => {
    state.success = null;
  },
  resetTdsTcsManagementMessage: (state: TdsTcsTypes) => {
    state.message = null;
  },
  resetTdsTcsManagementStatusCode: (state: TdsTcsTypes) => {
    state.statusCode = null;
  },

  resetTdsTcsManagementFetching: (state: TdsTcsTypes) => {
    state.fetching = false;
  },
  resetSavingEntryStatus: (state: TdsTcsTypes) => {
    state.savingEntry = false;
  },

  resetTdsPayableList: (state: TdsTcsTypes) => {
    state.tdsPayableList = [];
    state.tdsPayableTotalCount = null;
    state.tdsPayableTotalTds = null;
    state.tdsPayableFinancialYear = null;
    state.tdsPayableTotalTaxAmount = null;
  },

  resetTdsReportError: (state: TdsTcsTypes) => {
    state.tdsReportError = null;
  },
  resetTdsReportMessage: (state: TdsTcsTypes) => {
    state.tdsReportMessage = null;
  },
  resetTdsReportFetching: (state: TdsTcsTypes) => {
    state.tdsReportFetching = false;
  },
  resetTdsReportList: (state: TdsTcsTypes) => {
    state.tdsReportList = null;
  },
  resetTdsReportDetails: (state: TdsTcsTypes) => {
    state.tdsReportDetails = null;
  },
  resetApprovingTdsReportStatus: (state: TdsTcsTypes) => {
    state.approvingTdsReport = false;
  },
  resetAddingTdsReportCommentStatus: (state: TdsTcsTypes) => {
    state.addingTdsReportComment = false;
  },
  resetAddCommentTdsReportMessage: (state: TdsTcsTypes) => {
    state.addCommentTdsReportMessage = null;
  },
  resetSigningOffTdsReportStatus: (state: TdsTcsTypes) => {
    state.signingOffTdsReport = false;
  },
  resetTanNumberList: (state: TdsTcsTypes) => {
    state.tanNumberList = [];
  },
};
